var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reply"},[_c('h5',[_vm._v("评论")]),_vm._l((_vm.replies),function(item){return _c('div',[_c('OtherReplylist',{attrs:{"parentmsg":item}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }